module.exports = __webpack_public_path__ + "img/spaceCustomization.433c9487.jpg";